'use client'

import React from 'react'

import BorderBlack from '@images/brands/cheongdam/border-black.png'
import HairColour from '@images/brands/cheongdam/hair-colour.png'
import Ingredients from '@images/brands/cheongdam/ingredients.png'
import PumpOut from '@images/brands/cheongdam/pump-out.jpg'
import { Box, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const FastResult = () => {
  return (
    <VStack>
      <Box data-aos="fade-up" position={'relative'}>
        <Image src={BorderBlack} width={550} height={180} alt="border-black" />
        <Text
          textStyle={'fastResultTitleWhite'}
          color={'white'}
          position={'absolute'}
          textAlign={'center'}
          top="50%"
          left={'50%'}
          transform="translateX(-50%) translateY(-70%)"
          textTransform={'uppercase'}
          ml={2}
        >
          fast result! non-intrusive!
        </Text>
      </Box>
      <Image
        data-aos="fade-up"
        src={HairColour}
        width={550}
        height={180}
        alt="border-black"
      />
      <VStack data-aos="fade-up" gap={10}>
        <VStack>
          <Text textStyle={'fastResultTitle'} textTransform={'uppercase'}>
            natural
          </Text>
          <Text textStyle={'fastResultText'} textTransform={'uppercase'}>
            food grade darkeners
          </Text>
        </VStack>
        <VStack>
          <Text textStyle={'fastResultTitle'} textTransform={'uppercase'}>
            no ammonia
          </Text>
          <Text textStyle={'fastResultText'} textTransform={'uppercase'}>
            & no harmful ingredients
          </Text>
        </VStack>
        <VStack>
          <Text textStyle={'fastResultTitle'} textTransform={'uppercase'}>
            hair shine
          </Text>
          <Text textStyle={'fastResultText'} textTransform={'uppercase'}>
            & hair volume improvements
          </Text>
        </VStack>
      </VStack>
      <Image
        data-aos="fade-up"
        src={Ingredients}
        width={650}
        height={180}
        alt="border-black"
      />
      <Image
        data-aos="fade-up"
        src={PumpOut}
        width={650}
        height={180}
        alt="border-black"
      />
    </VStack>
  )
}

export default FastResult
